import { combineReducers } from 'redux';
import social from './social';

const reducers = {
  social,
};
export default combineReducers(reducers);
